import React, { useEffect, useState } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { } from 'react-bootstrap'
import * as s from '../Football/RegularSeason/NFL/NFLScoreboard.scss'
import SeasonSelector from '../Football/SeasonSelector'
import WeekSelector from '../Football/WeekSelector'
import NFLScoreboardGameDay from '../Football/RegularSeason/NFL/NFLScoreboardGameDay'
import { getNflScoreboard } from '@severed-links/common.redherrings-reducers/eliminator'
import { getFootballUrlParams } from '@severed-links/common.redherrings-constants'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'

const EliminatorNflScoreboard = () => {

    const dispatch = useDispatch()
    const params = useParams()
    const seasons = useSelector(state => state.eliminator.seasons)
    const nflScoreboards = useSelector(state => state.eliminator.nflScoreboards) 
    const c = getFootballUrlParams(params, seasons)
    const seasonId = ((c || {}).season || {}).seasonId
    const week = (c || {}).week
    const isPlayoffWeek = (c || {}).isPlayoffWeek || false
    const sb = nflScoreboards.find(x => x.seasonId === seasonId && x.weekNumber === week && x.isPlayoffWeek === isPlayoffWeek)
    const updateStandings = () => {
        if (seasonId && week) {
            dispatch(getNflScoreboard(c.season.seasonId, c.week, c.isPlayoffWeek))
        }
    }
    useEffect(() => { updateStandings() }, [dispatch, seasons, seasonId, week, isPlayoffWeek])

    if (!sb) return null
    return (
        <div className={s.container + ' ' + s.eliminator}>
            <div className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='football-ball' /></div>
                <div className={s.heroBody}>
                    <div className={s.eyebrow}>Eliminator</div>
                    <h2 className={s.title}>NFL Scoreboard</h2>
                    <div className={s.subtitle}>{sb.seasonName} · {sb.weekDisplay}</div>
                </div>
                <div className={s.controls}>
                    <div className={s.seasonSelector}><SeasonSelector seasons={seasons} season={c.season} /></div>
                    <div className={s.weekSelector}><WeekSelector seasons={seasons} season={c.season} week={'W' + c.week.toString()} /></div>
                </div>
            </div>
            <div className={s.gamesContainer}>
            {sb.gameDays && sb.gameDays.map((d, index) => 
                <NFLScoreboardGameDay gameDay={d} seasonId={sb.seasonId} seasonName={sb.seasonName} seasonMode={sb.seasonMode} week={sb.weekNumber} showLines={false}
                    key={`nfl-scoreboard-${sb.seasonId}-week-${sb.weekNumber}-day-${d.gameDate}`} />
            )}
            </div>
        </div>
    )
}

export default EliminatorNflScoreboard
